import { WizEvent } from '@wizeoo/akm-component-lib';

/** Evénements AllKeyMe */
export class AlkEvent extends WizEvent {
  /* EVENT TYPES */
  // affichage d'une vue
  public static SET_VIEW = 'SET_VIEW';

  /** contenu (données) */
  private _data: any;
  public get data(): any {
    return this._data;
  }

  /** contenant (composant physique pour coords) */
  private _physicalComponent: any;
  public get physicalComponent(): any {
    return this._physicalComponent;
  }

  /**
   * Constructor
   * @param pType Event type code
   * @param pData données
   */
  constructor(pType: string, pData?: any, pPhysicalComponent?: any) {
    super(pType, null);

    if (pData) {
      this._data = pData;
    }
    if (pPhysicalComponent) {
      this._physicalComponent = pPhysicalComponent;
    }
  }
}
